import type { QueryClient } from '@tanstack/react-query';
import type { BatchParams } from '@dealstack/frontend/app/services/dealstackAi/dealstackAi.types';
import { transactionsListFilter } from '../components/TransactionsPanel/TransactionsPanel.utils';
import { parseWorkspaceUrlState } from '../workspaceUrlState.utils';
import {
	batchesQueryOptions,
	batchQueryOptions,
	entityListQueryOptions,
	overviewQueryOptions,
	statusBarQueryOptions,
	transactionsPageQueryOptions,
} from './useDealstackAiQueries';

/**
 * Warms what the Securities category renders on arrival at `search`, with the panels' own filters, so
 * the hand-off from a finished run lands on rows instead of skeletons.
 */
export const prefetchResultsLanding = async (
	queryClient: QueryClient,
	params: BatchParams,
	search: string
): Promise<void> => {
	const url = parseWorkspaceUrlState(new URLSearchParams(search));
	await Promise.all([
		queryClient.prefetchQuery(batchesQueryOptions(params.dealId)),
		queryClient.prefetchQuery(batchQueryOptions(params)),
		queryClient.prefetchQuery(overviewQueryOptions(params)),
		queryClient.prefetchQuery(statusBarQueryOptions(params)),
		queryClient.prefetchQuery(
			entityListQueryOptions(params, { category: 'securities', tab: url.tab })
		),
		queryClient.prefetchQuery(
			entityListQueryOptions(params, { category: 'securities', tab: 'all' })
		),
		queryClient.prefetchQuery(
			transactionsPageQueryOptions(params, transactionsListFilter({}, url.quickFilter), 1)
		),
	]);
};
